interface Props extends React.HTMLAttributes<HTMLDivElement> {
  column?: boolean
  gap?: string,
}

export const Flex = ({children, column, gap, ...props}: React.PropsWithChildren<Props>) => (
  <div {...props} style={{display: "flex", flexDirection: column ? "column" : "row", gap: gap || "0", ...props.style}} >
    {children}
  </div>
);